const checkFloat = n => {
  if (Number(n) === n && n % 1 !== 0) {
    return n.toFixed(2);
  } else {
    return n;
  }
};

const calcSize = val => {
  const sizes = ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  if (val === 0) {
    return "0 Byte";
  } else if (!val) {
    return "-";
  }
  const i = Math.floor(Math.log(val) / Math.log(1024));
  return checkFloat(val / Math.pow(1024, i)) + " " + sizes[i];
};

export const calcByte = (val, format) => {
  const sizes = {
    Byte: 1,
    KB: 1024,
    MB: 1024 * 1024,
    GB: 1024 * 1024 * 1024,
    TB: 1024 * 1024 * 1024 * 1024
  };
  return val * sizes[format.toUpperCase()];
};

export default calcSize;
